import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { Branch } from '@/client/branches';
import { LazyLoadingMultiselect } from '@/components/form/generic/LazyLoadingMultiselect';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type BranchMultiselectInputProps = {
  onChange: (value: Branch[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: Branch[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const BranchesMultiselectInput: React.FC<
  BranchMultiselectInputProps
> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
  accountId,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const fetchBranches = isDisabled
    ? undefined
    : async (params: ListingRequest) =>
        await client.branches.getBranches(
          params,
          accountId || currentAccount?.id,
        );

  return (
    <LazyLoadingMultiselect
      fetchService={fetchBranches}
      filter
      label={t('branch')}
      display="chip"
      optionLabel="name"
      placeholder={t('branch.select')}
      maxSelectedItems={3}
      additionalFilters={additionalFilters}
      selectedValues={selectedOptions || []}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      isDisabled={isDisabled}
    />
  );
};
